import { ActionsUnion, createAction } from "store/helper";

import {
  IEntityFetchCollectionFailure,
  IEntityFetchCollectionSuccess,
  RequestAction,
  createEntityActionNames,
} from "../actions";

import {
  ICreateReplyAddressFailurePayload,
  ICreateReplyAddressPayload,
  ICreateReplyAddressSuccessPayload,
  IDeleteReplyAddressFailurePayload,
  IDeleteReplyAddressPayload,
  IDeleteReplyAddressSuccessPayload,
  IFetchReplyAddressFailurePayload,
  IFetchReplyAddressPayload,
  IFetchReplyAddressSuccessPayload,
  IReplyAddress,
  ISyncDeleteReplyAddressPayload,
  IUpdateReplyAddressFailurePayload,
  IUpdateReplyAddressPayload,
  IUpdateReplyAddressSuccessPayload,
} from "./interfaces";

export const ReplyAddressActionsNames = {
  ...createEntityActionNames("REPLY_ADDRESS"),
  SYNC_DELETE: "ENTITIES/REPLY_ADDRESSES/SYNC_DELETE",
};

export const ReplyAddressActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchCollection: (payload: Record<string, never>) =>
    createAction(ReplyAddressActionsNames.FETCH_COLLECTION[RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchCollectionSuccess: (payload: IEntityFetchCollectionSuccess<IReplyAddress>) =>
    createAction(ReplyAddressActionsNames.FETCH_COLLECTION[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchCollectionFailure: (payload: IEntityFetchCollectionFailure) =>
    createAction(ReplyAddressActionsNames.FETCH_COLLECTION[RequestAction.FAILURE], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetch: (payload: IFetchReplyAddressPayload) =>
    createAction(ReplyAddressActionsNames.FETCH_SINGLE[RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchSuccess: (payload: IFetchReplyAddressSuccessPayload) =>
    createAction(ReplyAddressActionsNames.FETCH_SINGLE[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchFailure: (payload: IFetchReplyAddressFailurePayload) =>
    createAction(ReplyAddressActionsNames.FETCH_SINGLE[RequestAction.FAILURE], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  create: (payload: ICreateReplyAddressPayload) =>
    createAction(ReplyAddressActionsNames.CREATE[RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  createSuccess: (payload: ICreateReplyAddressSuccessPayload) =>
    createAction(ReplyAddressActionsNames.CREATE[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  createFailure: (payload: ICreateReplyAddressFailurePayload) =>
    createAction(ReplyAddressActionsNames.CREATE[RequestAction.FAILURE], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  update: (payload: IUpdateReplyAddressPayload) =>
    createAction(ReplyAddressActionsNames.UPDATE[RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateSuccess: (payload: IUpdateReplyAddressSuccessPayload) =>
    createAction(ReplyAddressActionsNames.UPDATE[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateFailure: (payload: IUpdateReplyAddressFailurePayload) =>
    createAction(ReplyAddressActionsNames.UPDATE[RequestAction.FAILURE], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  delete: (payload: IDeleteReplyAddressPayload) =>
    createAction(ReplyAddressActionsNames.DELETE[RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteSuccess: (payload: IDeleteReplyAddressSuccessPayload) =>
    createAction(ReplyAddressActionsNames.DELETE[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteFailure: (payload: IDeleteReplyAddressFailurePayload) =>
    createAction(ReplyAddressActionsNames.DELETE[RequestAction.FAILURE], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  syncDelete: (payload: ISyncDeleteReplyAddressPayload) => createAction(ReplyAddressActionsNames.SYNC_DELETE, payload),
};

export enum ReplyAddressRequestActions {
  DELETE_REPLY_ADDRESS_REQUEST = "DELETE_REPLY_ADDRESS",
  CREATE_REPLY_ADDRESS_REQUEST = "CREATE_REPLY_ADDRESS",
  UPDATE_REPLY_ADDRESS_REQUEST = "UPDATE_REPLY_ADDRESS",
}

export type ReplyAddressAction = ActionsUnion<typeof ReplyAddressActions>;
